import EmailIcon from "@fortawesome/fontawesome-free/svgs/regular/envelope.svg";
import * as React from 'react';
export default {
  EmailIcon,
  React
};